<template>
    <iframe v-if="this.interactResult != null"
            :srcdoc="this.interactResult"></iframe>
</template>
<script>
import {mapState} from 'vuex';
import {services, eventBus} from "../../main"

export default {
    name: "ResultInteract",
    props: {
        challenge: {type: [Object], default: () => null}
    },
    data() {
        return {
            userProfileRequest: {loaded: false, error: null},
            interactResultRequest: {loaded: false, error: null},
            interactResult: null,
        }
    },
    created() {
        if (this.isAuthenticated) {
            this.userProfileRequest = services.userService.getUserProfile();
        }
        if (!this.isAuthenticated) {
            this.interactResultRequest = services.interactsService.getInteractResult(this.challenge.id, this.challenge.technology.language);
        }

        eventBus.$on('user-profile-changed', () => {
            this.userProfileRequest = {loaded: false, error: null};
            this.userProfileRequest = services.userService.getUserProfile();
        })
    },
    watch: {
        "interactResultRequest.loaded": function () {
            if (this.interactResultRequest.loaded && !this.interactResultRequest.error) {
                this.interactResult = this.interactResultRequest.html;
            }
        },
        "userProfileRequest.loaded": function () {
            if (this.userProfileRequest.loaded && !this.userProfileRequest.error) {
                this.interactResultRequest = services.interactsService.getInteractResult(this.challenge.id, this.challenge.technology.language, services.auth.getIDToken(), this.region, this.profession);
            }
        }
    },
    computed: {
        region: function () {
            if (!this.userProfileRequest.loaded) {
                return;
            }
            if (this.userProfileRequest.error) {
                return;
            }

            return this.userProfileRequest.user_profile.encoded_region;
        },
        profession: function () {
            if (!this.userProfileRequest.loaded) {
                return;
            }
            if (this.userProfileRequest.error) {
                return;
            }

            return this.userProfileRequest.user_profile.profession;
        },
        ...mapState([
            'isAuthenticated',
        ])
    }
}
</script>

<style scoped>
iframe {
    width: 100%;
    height: 300px;
    border: 0;
    overflow: hidden;
}

@media (max-width: 1361px) {
    iframe {
        height: 450px;
    }
}
</style>
